import { createContext, useEffect } from "react";
import FeatureFlagService from "services/FeatureFlagService";
import type { Status } from "types/Status";
import useStatus from "hooks/useStatus";

export type FeatureFlagStatus = Status;

export const FeatureFlagStatusContext = createContext<FeatureFlagStatus | undefined>(undefined);
FeatureFlagStatusContext.displayName = "FeatureFlagStatusContext";

interface FeatureFlagProviderProps {
  children?: React.ReactNode;
}

function FeatureFlagProvider(props: FeatureFlagProviderProps) {
  const { status, setStatus } = useStatus({ initialStatus: "fetching" });

  useEffect(() => {
    FeatureFlagService.init().finally(() => {
      setStatus("success");
    });
    return () => {
      FeatureFlagService.clear();
    };
  }, [setStatus]);

  return <FeatureFlagStatusContext.Provider value={status}>{props.children}</FeatureFlagStatusContext.Provider>;
}

export default FeatureFlagProvider;
